var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    { ref: "form", staticStyle: { width: "100%", "padding-top": "0px" } },
    [
      _c(
        "v-card-text",
        [
          _c("v-text-field", {
            attrs: {
              rules: [_vm.rules.required],
              required: "",
              label: "Alias name",
            },
            model: {
              value: _vm.formObject.newSynonymName,
              callback: function ($$v) {
                _vm.$set(_vm.formObject, "newSynonymName", $$v)
              },
              expression: "formObject.newSynonymName",
            },
          }),
          _vm._v(" "),
          _vm.isSystemAdmin
            ? [
                _c("v-subheader", { staticClass: "pl-0" }, [
                  _vm._v("System Administrator Settings"),
                ]),
                _vm._v(" "),
                _c("v-checkbox", {
                  staticClass: "mt-0",
                  attrs: {
                    color: "info",
                    label: "Make primary alias",
                    "persistent-hint": "",
                    hint: "The primary alias is the name used in reports",
                  },
                  model: {
                    value: _vm.formObject.isPrimary,
                    callback: function ($$v) {
                      _vm.$set(_vm.formObject, "isPrimary", $$v)
                    },
                    expression: "formObject.isPrimary",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          key: "alert",
          staticClass: "my-0",
          attrs: {
            outline: "",
            type: "warning",
            value: _vm.formObject.isPrimary,
          },
        },
        [
          _c("div", { staticClass: "primary--text" }, [
            _vm._v(
              "\n      The primary alias name shows up in reports, which may cause confusion if the primary alias does not match the\n      location name.\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }